import { useMemo } from "react";
import {
  useTable,
  useSortBy,
  useGlobalFilter,
  usePagination,
} from "react-table";
//import { ROWS_DATA, USER_COLUMNS } from "./columns";
import styled from "styled-components";
import { TablePagination } from "@mui/material";
import TableSearch from "../../Components/TableSearch/TableSearch";

const PanelsTable = ({ panels }) => {
  const DataTable = panels?.data?.data || [];

  const productData = useMemo(() => [...DataTable], []);
  const columnsData = useMemo(
    () =>
      DataTable[0]
        ? Object.keys(DataTable[0]).map((key) => {
            return {
              Header: key,
              accessor: key,
            };
          })
        : [],
    []
  );

  const tableInstance = useTable(
    { columns: columnsData, data: productData },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    state,
    setGlobalFilter,
  } = tableInstance;

  const { globalFilter } = state;

  return (
    <TableSTyled>
      <div className="tableFilter">
        <TableSearch filter={globalFilter} setFilter={setGlobalFilter} />
      </div>
      {DataTable && (
        <table {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                    {column.render("Header")}
                    <span>
                      {column.isSorted ? (column.isSortedDesc ? "+" : "-") : ""}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          {/* Apply the table body props */}
          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()}>{cell.render("Cell")} </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </TableSTyled>
  );
};

const TableSTyled = styled.div`
  overflow-x: auto;
  padding: 2rem 0;
  margin: 2rem 1rem;
  box-shadow: 0 5px 8px var(--box-shadow);
  border-radius: 1rem;
  background: var(--white);
  .tableFilter {
    margin: 1rem;
  }
  table {
    padding: 2rem 0;
    margin: 2rem auto;
    text-align: center;
    width: 100%;

    border-spacing: 0;

    td,
    th {
      padding: 1.2rem 0.5rem;

      /* min-width: 9rem; */
    }
    thead {
      color: var(--dark-gray);
    }
    tbody {
      tr {
        transition: all 0.2s;
        color: var(--gray);
        /* &:nth-child(odd) {
        background: var(--light-gray);
      } */
        &:hover {
          background: var(--light-sky);
          color: var(--dark);
        }
      }
    }
  }
`;

export default PanelsTable;
